<div class="modal-body">
  <div>
    <div [hidden]="imgSigLoading" [ngClass]="{'gc-hidden': !(!imgSigLoading)}">
      <div class="dropHere abx-image-signature-drop-here" [ngClass]="dragClass" (click)="openFileBrowser()" >
        <div [hidden]="image" [ngClass]="{'gc-hidden': !(!image)}">
          <!--<input class="form-control d-none" type="file" id="insertImgInput" (change)="upload($event, false)" accept=".jpg,.jpeg,.gif,.png" />-->
          <span class="dropImgHereOrClickToSelectFile">{{'DropImgHereOrClickToSelectFile' | translate}}</span>
          <span class="clickToSelectFile">{{'ClickToSelectFile' | translate}}</span>
        </div>
        <div [hidden]="!image" [ngClass]="{'gc-hidden': !(image)}" class="abx-signature-image-preview abx-signature-image-preview-no-border">
          <img data-src="data:image/png;base64,{{image}}" [ngClass]="{'gray-scale' : clientMode}" />
        </div>
      </div>
    </div>
    <div [hidden]="!imgSigLoading" [ngClass]="{'gc-hidden': !(imgSigLoading)}" class="abx-signature-image-preview-loading">
      <div style="height: 65px;"></div>
      <div class="loader-centered-small"></div>
    </div>
    <br />
    <div class="abx-insert-signature-footer-buttons">
      <button class="btn" (click)="cancel()">{{'Cancel' | translate}}</button>
      <button class="btn btn-default" [disabled]="!image || imgSigLoading" (click)="addImage()">{{'Apply' | translate}}</button>
    </div>
  </div>

  <div style="display: none;">
    <form id="insertImgInputForm">
      <input class="form-control d-none" (change)="upload($event, false)" type="file" id="insertImgInput" accept=".jpg,.jpeg,.gif,.png, .heic, .HEIC" />
    </form>
  </div>
</div>
